module.exports = __webpack_public_path__ + "img/Barcode.ec896cfc.svg";